var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoad2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    viewBox: "0 0 554.2 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, "\n      .st0 {\n        fill: #ee353f;\n        stroke-width: 0px;\n      }\n\t\t.cls-1 {\n\t\t\tfill: transparent;\n\t\t\tpointer-events: all;\n\t\t\tcursor: pointer;\n\t\t}\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1_PARCOURS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M456.1,1005.1c-8.5,0-15.9,5-19.3,12.2-37.7-6.3-116.8-19.6-165.3-29.1-.3-11.6-9.7-20.9-21.4-20.9s-15.5,4.7-19,11.6c-21.1-6.6-48.3-18.6-70.6-31.6-17.6-10.2-31-20.3-38.6-28.7,5.6-3.9,9.2-10.3,9.2-17.6s-2.9-12.2-7.4-16.2c13.4-16.2,38.7-34.7,61.1-49.4,19.8-13,42.1-26.3,65.1-39.4,3.9,4.9,9.9,8,16.7,8,11.8,0,21.4-9.6,21.4-21.4s-.4-5-1.3-7.2c13.6-7.5,27.1-14.8,40.1-21.9,36.6-19.9,68.3-37.1,86.6-49.4.2-.1.3-.2.5-.3,2.7,1.2,5.7,1.9,8.8,1.9,11.8,0,21.4-9.6,21.4-21.4s-9.6-21.4-21.4-21.4-10.9,2.2-14.7,5.8c-19.2-5.9-51.9-8.9-95-12.3-39.5-3.2-80.4-6.5-98-13.8-4-1.7-7.5-3.3-10.4-5,2.2-3.4,3.5-7.4,3.5-11.7,0-8.3-4.7-15.4-11.5-19,8.2-13.9,25.9-32.3,49-56.1l5.4-5.6c4.8-5,9.2-10.8,13.2-17.2,1.9.6,3.9.9,6,.9,11.8,0,21.4-9.6,21.4-21.4s-4.4-15-11-18.7c4.8-17.5,7.8-37.6,8.9-60.3,2.1-40.7-2-80.3-4.9-106.1,7.5-3.3,12.7-10.8,12.7-19.5s-9.6-21.4-21.4-21.4-21.4,9.6-21.4,21.4,9,20.8,20.2,21.4c2.9,25.4,6.8,64.2,4.8,103.8-1.1,22-4,41.4-8.6,58.1-.3,0-.5,0-.8,0-11.8,0-21.4,9.6-21.4,21.4s2.6,11.6,6.7,15.5c-3.5,5.7-7.4,10.8-11.7,15.2l-5.4,5.6c-25.7,26.6-43.8,45.3-51.9,60.6-11.7.2-21.1,9.7-21.1,21.4s9.6,21.4,21.4,21.4,7.2-.9,10.2-2.6c3.9,2.5,8.7,4.9,14.2,7.2,19.1,7.9,58.9,11.1,101.1,14.5,26,2.1,52.9,4.3,73.1,7.6,7.2,1.2,12.7,2.4,17.1,3.6-.7,2.1-1.1,4.4-1.1,6.8,0,4.9,1.6,9.4,4.4,12.9-18.2,11.9-48.6,28.5-83.7,47.5-13.2,7.2-27,14.7-40.8,22.3-3.8-3.6-9-5.8-14.6-5.8-11.8,0-21.4,9.6-21.4,21.4s.1,2.9.4,4.3c-23.3,13.3-46,26.9-66.3,40.1-31.9,20.9-53.2,38.3-64.7,53.1-1.6-.4-3.2-.6-5-.6-11.8,0-21.4,9.6-21.4,21.4s9.6,21.4,21.4,21.4,1.5,0,2.3-.1c9.7,12.4,27.7,24.5,43.5,33.7,23.2,13.4,51.3,25.9,73.3,32.7h0c0,11.9,9.6,21.4,21.4,21.4s15.8-4.9,19.3-12.1c48.7,9.6,127.4,22.8,165.4,29.1.3,11.5,9.8,20.8,21.4,20.8s21.4-9.6,21.4-21.4-9.6-21.4-21.4-21.4h0Z",
    id: "path1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "milestones",
    "data-name": "milestones"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 455.83472,
    cy: 1026.4875,
    r: 22,
    id: "ms1"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 250.80165,
    cy: 988.03308,
    r: 22,
    id: "ms2"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 109.33884,
    cy: 900.0744,
    r: 22,
    id: "ms3"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 266.52893,
    cy: 783,
    r: 22,
    id: "ms4"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 422.05786,
    cy: 683.34711,
    r: 22,
    id: "ms5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 186.26447,
    cy: 625.80994,
    r: 22,
    id: "ms6"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 270.2066,
    cy: 507.41321,
    r: 22,
    id: "ms7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 275.56198,
    cy: 303.05786,
    r: 22,
    id: "ms8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoad2);
export default __webpack_public_path__ + "static/media/road2.be47b292dd2bd9033a5495a0dea46d90.svg";
export { ForwardRef as ReactComponent };